import { render, staticRenderFns } from "./CompMenu.vue?vue&type=template&id=8539028e&scoped=true"
import script from "./CompMenu.vue?vue&type=script&lang=js"
export * from "./CompMenu.vue?vue&type=script&lang=js"
import style0 from "./CompMenu.vue?vue&type=style&index=0&id=8539028e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8539028e",
  null
  
)

export default component.exports